import { render, staticRenderFns } from "./displayList.vue?vue&type=template&id=22a2b190&scoped=true&"
import script from "./displayList.vue?vue&type=script&lang=js&"
export * from "./displayList.vue?vue&type=script&lang=js&"
import style0 from "./displayList.vue?vue&type=style&index=0&id=22a2b190&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a2b190",
  null
  
)

export default component.exports